"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var palette_1 = require("../theme/palette");
/*
    NOTE: This must import `ExternalLink` individually, instead of using the
    barrel file (i.e. `import { ExternalLink } from './link'`), as otherwise
    `react-router-dom` is required by all users of the `Footer`. This ensures
    sites that use an alternative router (i.e. those powered by say, NextJS)
    to be able to use the `Footer`.
*/
var ExternalLink_1 = require("./link/ExternalLink");
var typography_1 = require("./typography");
var Layout_1 = require("./Layout");
var layout_1 = require("../layout");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        var _this = this;
        var contrast = this.props.variant === 'dark' ? true : undefined;
        return (React.createElement(layout_1.LayoutContext.Consumer, null, function (_a) {
            var layoutVariant = _a.layoutVariant;
            return (React.createElement(StyledFooter, { contrast: contrast, layout: layoutVariant, className: _this.props.className },
                _this.props.setPageBackground ? (React.createElement(WithPageBackground, { color: contrast ? palette_1.palette.background.dark : palette_1.palette.background.light })) : null,
                _this.props.children ? (_this.props.children) : (React.createElement(typography_1.Body, null,
                    React.createElement(ExternalLink_1.ExternalLink, { contrast: contrast, href: "https://allenai.org" }, "\u00A9 The Allen Institute for Artificial Intelligence"),
                    ' ',
                    "- All Rights Reserved |",
                    ' ',
                    React.createElement(ExternalLink_1.ExternalLink, { contrast: contrast, href: "https://allenai.org/privacy-policy.html" }, "Privacy Policy"),
                    ' ',
                    "|",
                    ' ',
                    React.createElement(ExternalLink_1.ExternalLink, { contrast: contrast, href: "https://allenai.org/terms.html" }, "Terms of Use")))));
        }));
    };
    Footer.defaultProps = {
        setPageBackground: true
    };
    return Footer;
}(React.PureComponent));
exports.Footer = Footer;
var WithPageBackground = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    html, body {\n        background: ", ";\n    }\n"], ["\n    html, body {\n        background: ", ";\n    }\n"])), function (_a) {
    var color = _a.color;
    return "" + color;
});
var StyledFooter = styled_components_1.default(Layout_1.LayoutFooter)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    && {\n        background: ", ";\n        color: ", ";\n        text-align: ", ";\n    }\n"], ["\n    && {\n        background: ",
    ";\n        color: ",
    ";\n        text-align: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme, contrast = _a.contrast;
    return contrast ? theme.palette.background.dark : theme.palette.background.light;
}, function (_a) {
    var theme = _a.theme, contrast = _a.contrast;
    return contrast ? theme.palette.text.contrast : theme.palette.text.default;
}, function (_a) {
    var layout = _a.layout;
    return (layout !== 'app' ? 'center' : null);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Footer.js.map